import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export interface ICouponCreationResponse {
  status: boolean;
  message: string;
  data: {
    coupon_id: string;
  };
}
export const useVaccinationOCRUpdationAPI = () => {
  const configuration = useConfiguration();

  const { sendCurl } = useCurlLogger();
  const dispatch = useAppDispatch();
  const { captureError, toastNotification } = useAPIUtils();
  const execute = useCallback(
    async (filterParams: any) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .put(`${CUSTOMER_APIS?.VACCINATION_OCR_UPDATE?.baseURL}`, filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICouponCreationResponse>) => {
            if (res.data.status) {
              toastNotification(res.data.message);
              return { status: true, message: "" };
            } else {
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);

            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
